import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

import RubricSetup from "Administrator/commonComponents/AssessmentToolSetup/routes/RubricSetup";
import ChecklistSetup from "Administrator/commonComponents/AssessmentToolSetup/routes/ChecklistSetup";
import SinglePointRubricSetup from "Administrator/commonComponents/AssessmentToolSetup/routes/SinglePointRubricSetup";
import ScoreBasedRubricSetup from "Administrator/commonComponents/AssessmentToolSetup/routes/ScoreBasedRubricSetup";
import StandardBasedRubricSetup from "Administrator/commonComponents/AssessmentToolSetup/routes/StandardBasedRubricSetup";

export default store => ({
  path: "assessment-tool",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
    ]).then(([importedModule0]) => importedModule0.default)
  ),
  childRoutes: [
    RubricSetup(store),
    ChecklistSetup(store),
    SinglePointRubricSetup(store),
    ScoreBasedRubricSetup(store),
    StandardBasedRubricSetup(store),
  ],
});
